import axios from 'axios';
import * as environmentService from '../environment/environmentService';
import * as oauthService from '../oauth/oauthService';

const ProfileService = {
    getUserData: () => {
        return axios.get(`${environmentService.getVidCloudMgmtUrl()}/vidmobileuser/`, oauthService.oauthHeaders());
    },

    getSignatureImage: (legalid) => {
        return axios.get(`${environmentService.getVidCloudMgmtUrl()}/vidmobileusers/${legalid}/signatureimage`, oauthService.oauthHeaders());
    },

    sendSignatureImageToViDSigner: (legalid, signatureImageDTO) => {
        return axios.put(`${environmentService.getVidCloudMgmtUrl()}/vidmobileusers/${legalid}/signatureimage`, signatureImageDTO, oauthService.oauthHeaders());
    },

    updateUserData: (updateData) => {
        return axios.put(`${environmentService.getVidCloudMgmtUrl()}/vidmobileuser/`, updateData, oauthService.oauthHeaders());
    },

    updateUserPassword: (vidMobileUserGUID, passwordBody, token, env) => {
        return axios.put(`${environmentService.getVidCloudMgmtUrl(env)}/vidmobileusers/${vidMobileUserGUID}/password`, passwordBody, oauthService.oauthHeadersWithToken(token));
    }
};

export default ProfileService;

